import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Divider,
  Dropdown,
  Grid,
  Form,
  Table,
  Icon,
  Popup,
  Card,
} from 'semantic-ui-react';
import { ageOptions, genderOptions, ethnicityOptions } from '../influencer-form/influencer-form-options';

const resetLink = {
  cursor: 'pointer',
  color: '#20c49e',
};

const noMinWidth = {
  minWidth: 'unset',
};

const searchIcon = {
  name: 'search',
};

const headerCellStyle = {
  height: 51,
};

const perPageOptions = [
  { key: 25, value: 25, text: '25' },
  { key: 50, value: 50, text: '50' },
  { key: 100, value: 100, text: '100' },
];

const INITIAL_STATE = {
  term: '',
  searchType: '',
  platform: '',
  min: '',
  max: '',
  minInstagramEngagementRate: '',
  maxInstagramEngagementRate: '',
  country: '',
  hasEmail: false,
  instagramPrivate: false,
  instagramBusinessAccount: false,
  ageGroup: '',
  gender: '',
  ethnicity: '',
};

class InfluencerFilter extends Component {
  constructor(props) {
    super();
    const { filter, withEmailCheckbox, defaultSearchType, defaultCountry } = props;
    this.state = {
      ...INITIAL_STATE,
      ...filter,
      hasEmail: withEmailCheckbox,
      searchType: defaultSearchType,
      country: defaultCountry || '',
    };
  }

  onValueChanged = (event, { name, value, checked }) => {
    this.setState({
      [name]: value || checked,
    });
  };

  onDropdownChange = (event, { name, value }) => {
    this.setState({
      [name]: value,
    });
  }

  onFilterClear = () => {
    const { onSearchFormSubmit } = this.props;
    this.setState({
      ...INITIAL_STATE,
    }, onSearchFormSubmit({ ...INITIAL_STATE }));
  }

  onSearchButtonClick = () => {
    const { onSearchFormSubmit } = this.props;
    const {
      term,
      searchType,
      platform,
      min,
      max,
      minInstagramEngagementRate,
      maxInstagramEngagementRate,
      country,
      hasEmail,
      instagramPrivate,
      instagramBusinessAccount,
      ageGroup,
      gender,
      ethnicity,

    } = this.state;


    onSearchFormSubmit(
      {
        term,
        searchType,
        platform,
        min,
        max,
        minInstagramEngagementRate,
        maxInstagramEngagementRate,
        country,
        hasEmail,
        instagramPrivate,
        instagramBusinessAccount,
        ageGroup,
        gender,
        ethnicity,
      },
    );
  }

  render() {
    const {
      term,
      searchType,
      min,
      max,
      country,
      platform,
      hasEmail,
      minInstagramEngagementRate,
      maxInstagramEngagementRate,
      instagramBusinessAccount,
      instagramPrivate,
      ageGroup,
      gender,
      ethnicity,
    } = this.state;

    const {
      countries,
      platforms,
      isLoadingCountries,
      isLoading,
      reportUrls,
      onPerPageChange,
      currentPerPage,
      withEmailCheckbox,
      withInstagramPrivateCheckbox,
      withBusinessAccountCheckbox,
      withDemographicsFilter,
    } = this.props;

    const downloadReportLinkAvailable = reportUrls.csv || reportUrls.xlsx;

    const searchTypes = [
      {
        key: 'handles',
        text: 'name/handle',
        value: 'handles',
      },
      {
        key: 'email',
        text: 'email',
        value: 'email',
      },
      {
        key: 'hashtags',
        text: 'hashtags',
        value: 'instagramHashtags',
      },
    ];

    return (
      <Table>
        <Table.Header fullWidth>
          <Table.HeaderCell width={8} style={headerCellStyle}>
            Filters
          </Table.HeaderCell>
          <Table.HeaderCell width={8} textAlign="right" style={headerCellStyle}>
            <a style={resetLink} onClick={this.onFilterClear}>Clear filter<Icon name="delete" /></a>
          </Table.HeaderCell>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan={2}>
              <Form>
                <span style={{ display: 'flex' }}>
                  <Popup
                    trigger={
                      <Form.Input
                        width={9}
                        placeholder="Search..."
                        value={term}
                        name="term"
                        onChange={this.onValueChanged}
                      />
                    }
                    content="Use the Tag Search below to search content tags!"
                  />
                  <Form.Select
                    width={7}
                    style={noMinWidth}
                    placeholder="name/handle"
                    name="searchType"
                    value={searchType}
                    options={searchTypes}
                    onChange={this.onValueChanged}
                  />
                </span>
                {withEmailCheckbox &&
                <Form.Checkbox
                  label="Has email"
                  name="hasEmail"
                  checked={hasEmail}
                  onChange={this.onValueChanged}
                />}
                {
                  withInstagramPrivateCheckbox &&
                  <Form.Checkbox
                    label="Instagram Private"
                    name="instagramPrivate"
                    checked={instagramPrivate}
                    onChange={this.onValueChanged}
                  />
                }
                {
                  withBusinessAccountCheckbox &&
                  <Form.Checkbox
                    label="Instagram business account"
                    name="instagramBusinessAccount"
                    checked={instagramBusinessAccount}
                    onChange={this.onValueChanged}
                  />
                }
                <Form.Select
                  label="channel"
                  placeholder="channel"
                  name="platform"
                  value={platform}
                  options={platforms}
                  onChange={this.onValueChanged}
                />
                { platform && <Card>
                  <Card.Content>
                    Followers
                    <Form.Group>
                      <Form.Input
                        type="number"
                        width={8}
                        label="more than"
                        name="min"
                        value={min}
                        placeholder="min. followers"
                        onChange={this.onValueChanged}
                      />
                      <Form.Input
                        type="number"
                        width={8}
                        label="less than"
                        name="max"
                        value={max}
                        placeholder="max. followers"
                        onChange={this.onValueChanged}
                      />
                    </Form.Group>
                  </Card.Content>
                </Card> }
                { platform === 'instagram' && <Card>
                  <Card.Content>
                  Engagement Rate
                    <Form.Group>
                      <Form.Input
                        type="number"
                        width={8}
                        label="more than"
                        name="minInstagramEngagementRate"
                        value={minInstagramEngagementRate}
                        placeholder="min. E.R."
                        onChange={this.onValueChanged}
                      />
                      <Form.Input
                        type="number"
                        width={8}
                        label="less than"
                        name="maxInstagramEngagementRate"
                        value={maxInstagramEngagementRate}
                        placeholder="max. E.R."
                        onChange={this.onValueChanged}
                      />
                    </Form.Group>
                  </Card.Content>
                </Card> }
                <Form.Select
                  label="country"
                  placeholder="country"
                  name="country"
                  value={country}
                  loading={isLoadingCountries}
                  options={countries}
                  onChange={this.onValueChanged}
                />

                { withDemographicsFilter &&
                  <Card>
                    <Card.Content>
                      <Form.Select
                        label="Age"
                        placeholder="Select age group"
                        name="ageGroup"
                        value={ageGroup}
                        options={ageOptions}
                        onChange={this.onValueChanged}
                        clearable
                      />
                      <Form.Select
                        label="Gender"
                        placeholder="Select gender"
                        name="gender"
                        value={gender}
                        options={genderOptions}
                        onChange={this.onValueChanged}
                        clearable
                      />
                      <Form.Select
                        label="Ethnicity"
                        placeholder="Select ethnicity"
                        name="ethnicity"
                        value={ethnicity}
                        options={ethnicityOptions}
                        onChange={this.onValueChanged}
                        clearable
                      />
                    </Card.Content>
                  </Card>
                }
                <Divider />
                <Button
                  content="Search"
                  icon="search"
                  color="pink"
                  fluid
                  loading={isLoading}
                  onClick={this.onSearchButtonClick}
                />
              </Form>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell colSpan={2}>
              {reportUrls && <Grid verticalAlign="middle">
                <Grid.Row>
                  {downloadReportLinkAvailable &&
                    <Grid.Column width={8}>Download influencers as</Grid.Column>
                  }
                  {reportUrls && reportUrls.csv && <Grid.Column width={3}>
                    <a className="text" style={resetLink} href={reportUrls.csv}><Icon name="cloud download" />CSV</a>
                  </Grid.Column>}
                  {downloadReportLinkAvailable && reportUrls.xlsx && <Grid.Column width={3} >
                    <a href={reportUrls.xlsx} style={resetLink} className="text"><Icon name="cloud download" />XLSX</a>
                  </Grid.Column>}
                </Grid.Row>
              </Grid>}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell colSpan={2}>
              <Grid verticalAlign="middle">
                <Grid.Row>
                  <Grid.Column computer={8} mobile={16}>Influencers per page</Grid.Column>
                  <Grid.Column computer={8} mobile={16}>
                    <Dropdown
                      fluid
                      selection
                      value={currentPerPage}
                      placeholder="per page"
                      onChange={onPerPageChange}
                      options={perPageOptions}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

InfluencerFilter.propTypes = {
  countries: PropTypes.array.isRequired,
  onSearchFormSubmit: PropTypes.func.isRequired,
  platforms: PropTypes.array.isRequired,
  isLoadingCountries: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  reportUrls: PropTypes.object.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  currentPerPage: PropTypes.number.isRequired,
  withEmailCheckbox: PropTypes.bool,
  withInstagramPrivateCheckbox: PropTypes.bool,
  withBusinessAccountCheckbox: PropTypes.bool,
  defaultSearchType: PropTypes.string,
  withDemographicsFilter: PropTypes.bool,
};
InfluencerFilter.defaultProps = {
  withEmailCheckbox: false,
  withInstagramPrivateCheckbox: false,
  withBusinessAccountCheckbox: false,
  defaultSearchType: '',
  withDemographicsFilter: false,
};
export default InfluencerFilter;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-filter/index.js
 **/